var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_twitter",
    transform: "translate(2268 20892)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11978",
    "data-name": "Rectangle 11978",
    width: 36,
    height: 36,
    transform: "translate(-2268 -20892)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32294",
    "data-name": "Path 32294",
    d: "M26.895-10.312A13.524,13.524,0,0,0,30-13.535a13.216,13.216,0,0,1-3.516,1,6.106,6.106,0,0,0,2.7-3.4,12.517,12.517,0,0,1-3.926,1.465,6.959,6.959,0,0,0-2.021-1.406,5.87,5.87,0,0,0-2.49-.527,5.942,5.942,0,0,0-3.047.82,6.021,6.021,0,0,0-2.227,2.256,6.1,6.1,0,0,0-.82,3.076,8.54,8.54,0,0,0,.117,1.406,17.031,17.031,0,0,1-7.061-1.875,16.965,16.965,0,0,1-5.6-4.57,5.89,5.89,0,0,0-.879,3.076,5.91,5.91,0,0,0,.762,2.959A6.826,6.826,0,0,0,3.984-7.031a5.792,5.792,0,0,1-2.754-.82v.117A5.9,5.9,0,0,0,2.637-3.867,6.2,6.2,0,0,0,6.152-1.7a7.81,7.81,0,0,1-1.641.176q-.527,0-1.113-.059A6.119,6.119,0,0,0,5.537,1.436a5.723,5.723,0,0,0,3.6,1.2A12.2,12.2,0,0,1,1.465,5.273q-.82,0-1.465-.059A17.071,17.071,0,0,0,9.434,7.969a16.9,16.9,0,0,0,9.551-2.754A16.733,16.733,0,0,0,24.9-1.406a17.374,17.374,0,0,0,2.051-8.145A3.491,3.491,0,0,0,26.895-10.312Z",
    transform: "translate(-2265 -20870.625)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon_twitter.7786857b40256e7e1d09bc38711850b6.svg";
export { ForwardRef as ReactComponent };